import type { Template } from "@/types";

export const PO_02_H1_V1: Template[] = [
    {
        id: "po-02-h1v1-01",
        name: "PO 01 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 60, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 813, y: 183, width: 323, height: 464, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-02",
        name: "PO 02 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 60, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 761, y: 109, width: 424, height: 608, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-03",
        name: "PO 03 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 60, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 649, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-04",
        name: "PO 04 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 208, width: 649, height: 413, rotation: 0, imageRotation: 0 },
            { id: "2", x: 686, y: 0, width: 574, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-05",
        name: "PO 05 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 55, y: 132, width: 806, height: 558, rotation: 0, imageRotation: 0 },
            { id: "2", x: 868, y: 132, width: 375, height: 558, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-06",
        name: "PO 06 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 115, width: 888, height: 598, rotation: 0, imageRotation: 0 },
            { id: "2", x: 896, y: 115, width: 401, height: 597, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-07",
        name: "PO 07 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 112, y: 109, width: 424, height: 608, rotation: 0, imageRotation: 0 },
            { id: "2", x: 709, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-08",
        name: "PO 08 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 709, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-09",
        name: "PO 09 - H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 37, y: 0, width: 574, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 649, y: 208, width: 649, height: 413, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h1v1-10",
        name: "PO 10- H1V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v1_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 163, y: 183, width: 323, height: 464, rotation: 0, imageRotation: 0 },
            { id: "2", x: 709, y: 246, width: 528, height: 337, rotation: 0, imageRotation: 0 }
        ],
    }
];